export const DEFAULT_CRITERIA = {
  greenTolerance: 5,
  orangeTolerance: 10,
  priority: { code: '1', name: '1' },
};

export const DEFAULT_REQUEST_FORMAT_CRITERIA = {
  greenTolerance: 0.05,
  orangeTolerance: 0.1,
  priority: 1,
};
